import React from 'react';
import SalesConciergeHeader from '../../components/AiSalesLanding/Header/Header';
import Nav from '../../components/landing/navbar/navbar';
import AIConciergeFeaturesComponent from '../../components/AiSalesLanding/Features/Features';
import StackableCarousel from '../../components/AiSalesLanding/StackableCarousel/StackableCarousel';
import FeatureDemo from '../../components/AiSalesLanding/FeatureDemo/FeatureDemo';
import Footer from '../../components/landing/footer';
import Hero from '../../components/landing/footerCta';

const AiSalesLandingPage = () => {
  return (
    <>
      <Nav />
      <SalesConciergeHeader />
      <AIConciergeFeaturesComponent />
      <StackableCarousel />
      <FeatureDemo />
      <Hero />
      <Footer/>
    </>
  );
};

export default AiSalesLandingPage;
